// extracted by mini-css-extract-plugin
module.exports = {"card":"XtrfCard_card__22M0O","divider":"XtrfCard_divider__2CXr4","body":"XtrfCard_body__1jden","firstElement":"XtrfCard_firstElement__1SMw3"};